import axios from 'axios'
import { AnimatePresence, motion } from 'framer-motion'
import { useContext, useEffect, useState } from 'react'
import { HiDotsVertical } from 'react-icons/hi'
import { MdHistory } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { ColumnsTable, IFoodOrder } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { ThemeContext } from '../../context/ThemeContext'
import { RootState } from '../../redux/store'
import { transformDate } from '../../utils/utils'
import WatchDetails from './WatchDetails'

const server = process.env.REACT_APP_SERVER_URL
const HistoricFoodOrder = () => {
  const { theme } = useContext(ThemeContext)
  const user = useSelector((state: RootState) => state.auth.user)
  const userPlan = user?.['custom:user_plan']
  const isEmprendedorUser =
    userPlan === 'emprendedor' || userPlan === 'estudiantil'
  const [menuVisible, setMenuVisible] = useState('')

  const [orders, setOrders] = useState<IFoodOrder[]>([])

  const [loading, setLoading] = useState(false)

  const [numberOfPages, setNumberOfPages] = useState(0)

  const [currentPage, setCurrentPage] = useState(0)

  const [showItems, setShowItems] = useState<IFoodOrder | null>(null)

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'startedDate',
      key: 'startedDate',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(new Date(record?.date).toISOString())}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Nombre mesa',
      dataIndex: 'foodTable.name',
      key: 'foodTable.name',
    },
    {
      title: 'Nro orden',
      dataIndex: 'foodOrderCode',
      key: 'foodOrderCode',
    },
    {
      title: 'Nro de factura',
      dataIndex: 'sale.invoiceCode',
      key: 'sale.invoiceCode',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {record?.sale?.invoiceCode ? record?.sale?.invoiceCode : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Mesonero',
      dataIndex: 'user.name',
      key: 'user.name',
    },

    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      key: '',
      render: (id: string, foodOrder: any) => {
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={id === menuVisible}
              onClose={() => setMenuVisible('')}
              options={{
                onWatchDetails: async () => {
                  console.log('VER', foodOrder)
                  setShowItems(foodOrder)
                },
              }}
            >
              <HiDotsVertical
                className="cursor-pointer text-gray-400"
                onClick={() => setMenuVisible(id)}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const onGetOrders = async (page: number = currentPage) => {
    setLoading(true)
    setCurrentPage(page)
    const response = await axios.get(
      `${server}/food-order?active=false&pageNumber=${page + 1}&pageSize=10`
    )
    setOrders(response.data.orders)
    setNumberOfPages(response.data.numberOfPages)
    setLoading(false)
  }

  useEffect(() => {
    // No cargar datos si es plan emprendedor
    if (!isEmprendedorUser) {
      onGetOrders()
    }
  }, [isEmprendedorUser])

  // Mostrar mensaje de upgrade si es plan emprendedor
  if (isEmprendedorUser) {
    return (
      <div className="flex flex-col justify-center items-center h-full p-4">
        <div
          className="p-8 rounded-lg shadow-lg max-w-2xl text-center"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="mb-6">
            <MdHistory
              className="mx-auto mb-4"
              size={64}
              style={{ color: '#507CDC' }}
            />
          </div>
          <h2 className="text-2xl font-bold mb-4 dark:text-white">
            Funcionalidad Premium
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            Para ver el historial de comandas debes mejorar tu plan a{' '}
            <strong className="text-primary">"PYME"</strong>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            El plan Corporativo incluye historial completo de comandas con
            búsqueda avanzada, reportes detallados, ventas por mesa, seguimiento
            de mesoneros y mucho más.
          </p>
        </div>
      </div>
    )
  }

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Table
            data={orders}
            columns={columns}
            loading={loading}
            pages={numberOfPages}
            pageSelected={currentPage}
            setLoading={setLoading}
            setPageSelected={(page) => onGetOrders(page)}
          />
        </motion.div>
      </AnimatePresence>

      <Modal
        xlClasses="w-[750px]"
        display={showItems !== null}
        onClose={() => setShowItems(null)}
      >
        <WatchDetails defaultValues={showItems} />
      </Modal>
    </>
  )
}

export default HistoricFoodOrder
